import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";

/**
 * 文本控件
 */
export class TextControl implements IControl{
    
    /**
     * 获取控件类型，返回值：文本控件类型
     */
    getControlType(): ControlType {
        return ControlType.Text;
    }

    /**
     * 默认显示
     */
    placeholder:string;
    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;
    /**是否显示label */
    showLabel:boolean;
    /**是否必填 */
    required:boolean;
}